import React from "react";
import { PeekBox, PeekButton, PeekStack, PeekTypography } from "@piiqtechnologies/ui-components";
export const LandingLayout = ({ title, subtitle, children, actionButtonText, onActionButton, pageHeader, }) => {
    return (React.createElement(PeekStack, { width: "100%", height: "100dvh", direction: "column", sx: { overflowY: "auto", overflowX: "hidden" } },
        React.createElement(PeekBox, { sx: { px: { xs: 2, md: 4 }, pt: { xs: 2, md: 3 }, pb: 1, flexShrink: 0 } },
            React.createElement(PeekBox, { component: "img", 
                // @ts-ignore
                src: "/images/peek_discover_dark_logo.svg", alt: "Peek Logo", sx: {
                    width: "100px",
                    height: "auto",
                    objectFit: "cover",
                    cursor: "pointer",
                }, onClick: () => {
                    window.open("https://www.peek.us/", "_blank", "noreferrer");
                } })),
        pageHeader ? (React.createElement(PeekStack, { gap: 2, alignSelf: "center", width: "80vw" },
            pageHeader,
            children)) : (React.createElement(PeekStack, { direction: "column", alignItems: "center", justifyContent: "center", alignSelf: "center", spacing: 5, sx: {
                width: "100%",
                flex: 1,
                minHeight: 0,
                px: { xs: 2, md: 3 },
                textAlign: "center",
            } },
            React.createElement(PeekStack, { gap: 3, alignItems: "center", justifyContent: !children ? "center" : undefined, maxWidth: children ? "100%" : "500px", sx: { flex: 1, minHeight: 0, overflowX: { xs: "auto", md: "visible" } } },
                React.createElement(PeekStack, { spacing: 2.5, justifySelf: "center", pb: 2 },
                    React.createElement(PeekTypography, { variant: "h1", fontSize: "32px", fontWeight: "fontWeightLight" }, title),
                    React.createElement(PeekTypography, { variant: "h2", fontWeight: "fontWeightLight", color: "info.main" }, subtitle),
                    onActionButton && (React.createElement(PeekButton, { fullWidth: true, size: "large", variant: "contained", color: "secondary", onClick: onActionButton }, actionButtonText))),
                children)))));
};
export default LandingLayout;
